<!-- Breadcrumb -->
<div class="mb-5">
  <dpac-breadcrumb [items]="breadcrumbs" />
</div>

<dpac-page-layout
  title="Dettaglio collezione"
  [showBackButton]="true"
  mode="stack"
  gap="gap-6">

  <!-- Extra buttons in header -->
  <div header-extra class="flex items-center gap-3">
    <dpac-button classe="secondary" label="Salva" (onClick)="saveCurrentStep()" />
  </div>

    <!-- Collection Header Card -->
    <dpac-collection-header
      [title]="idCollezioneModal().titolo || 'Titolo di Esempio della Collezione di Default'"
      [code]="'' + (idCollezioneModal().id || '1234567890')"
      [description]="collectionDescrizione()"
      [image]="coverImagePreview() || ''"
      [status]="mappaCompleted() ? 'Visibile in Mappa' : 'Bozza'"
      [statusVariant]="mappaCompleted() ? 'success' : 'default'"
    />

    <!-- Wizard Steps & Content Container -->
    <div class="mt-6 border border-gray-200 rounded-lg overflow-hidden">
      <!-- Tabs Area -->
      <div class="flex justify-between items-center bg-white px-6 pt-6">
        <div>
          <dpac-wizard-steps
            [tabs]="stepLabels()"
            [value]="current().label"
            (changeTab)="onTabChange($event)"
          />
        </div>

        <div>
          <dpac-stepper-number [tabs]="stepLabels()" [value]="current()?.label" />
        </div>

      </div>



      <!-- Step Content Area -->
      <div class="p-6">
        <!-- ═══════════════ STEP 1: Dati anagrafici ═══════════════ -->
      @if (current().key === 'anagrafici') {
      <form [formGroup]="formDataAnagrafica">

        <!-- Sezione: Soggetto Compilatore (readonly) -->
        <section class="mb-8">
          <h3 class="section-title">Dati anagrafici</h3>

          <div class="gap-x-6 gap-y-4 grid max-md:grid-cols-1 md:grid-cols-2">
            <dpac-input-field label="Nome" placeholder="Nome" formControlName="nome" [readonly]="true" />
            <dpac-input-field label="Cognome" placeholder="Cognome" formControlName="cognome" [readonly]="true" />
            <dpac-input-field label="Email" placeholder="Email" formControlName="email" type="email"
              [readonly]="true" />
            <dpac-input-field label="Ente di appartenenza" placeholder="Ente di appartenenza"
              formControlName="enteAppartenenza" [readonly]="true" />
            <div class="col-span-full">
              <dpac-input-field label="Professione/Ruolo" placeholder="Professione/Ruolo"
                formControlName="professioneRuolo" [readonly]="true" />
            </div>
          </div>
        </section>

        <!-- Sezione: Proprietario della collezione digitale -->
        <section class="mb-8">
          <h3 class="section-title">Proprietario della collezione digitale</h3>

          <div class="gap-x-6 gap-y-4 grid max-md:grid-cols-1 md:grid-cols-2">
            <dpac-input-field
              [label]="formDataAnagrafica.get('tipologia')?.value === 'PR004' ? 'Nome' : 'Nominativo'"
              [placeholder]="formDataAnagrafica.get('tipologia')?.value === 'PR004' ? 'Nome' : 'Nominativo'"
              formControlName="propNome" [required]="true" />

            @if (formDataAnagrafica.get('tipologia')?.value === 'PR004') {
            <dpac-input-field label="Cognome" placeholder="Cognome" formControlName="propCognome"
              [required]="true" />
            }

            <dpac-select label="Tipologia" placeholder="Seleziona" [options]="tipologie()"
              formControlName="tipologia" [required]="true"
              [optionLabel]="'label'" [optionValue]="'value'" />

            <dpac-select label="Categoria" placeholder="Seleziona" [options]="categorie()"
              formControlName="categoria" [required]="true"
              [optionLabel]="'label'" [optionValue]="'value'" />

            <dpac-input-field label="Codice identificativo" placeholder="Codice identificativo"
              formControlName="codiceIdentificativo"
              labelTooltip="ISIL, ESC, Codice fiscale"
              [labelTooltipIcon]="{src: './assets/icons/Vector.svg'}"
              />

            <dpac-input-field label="Indirizzo (sede legale)" placeholder="Indirizzo (sede legale)"
              formControlName="indirizzo" [required]="true" />
            <dpac-input-field label="Civico" placeholder="Civico" formControlName="civico" />
            <dpac-input-field label="CAP" placeholder="CAP" formControlName="cap" [required]="true" />
            <dpac-input-field label="Comune" placeholder="Comune" formControlName="comune" [required]="true" />
            <dpac-input-field label="Provincia" placeholder="Provincia" formControlName="provincia"
              [required]="true" />

            <div [class.col-span-full]="formDataAnagrafica.get('tipologia')?.value === 'PR004'">
              <dpac-input-field label="Sito web dell'ente" placeholder="Sito web dell'ente" formControlName="sitoWeb" />
            </div>
          </div>
        </section>
      </form>
      }

      <!-- ═══════════════ STEP 2: Collezione digitale ═══════════════ -->
      @if (current().key === 'digitale') {
      <form [formGroup]="formDataDigitale">

        <!-- Sezione: Collezione digitale -->
        <section class="mb-8">
          <h3 class="section-title">Collezione digitale</h3>

          <div class="gap-x-6 gap-y-4 grid max-md:grid-cols-1 md:grid-cols-2">
            <div class="col-span-full">
              <dpac-input-field label="Titolo" placeholder="Titolo della collezione" formControlName="titolo"
                [required]="true" />
              <p class="mt-1 text-gray-500 text-xs text-wrap">Formula un titolo chiaro, specifico e distinguibile.</p>
            </div>
            <div class="col-span-full">
              <dpac-textarea label="Descrizione" placeholder="Inserisci qui la descrizione"
                formControlName="descrizione" [required]="true" [showCharCount]="false" />
              <p class="mt-1 text-gray-500 text-xs text-wrap">Breve descrizione, da visualizzare in mappa, del contenuto della collezione digitale.</p>
            </div>

            <dpac-select label="Tipologia di beni digitalizzati" placeholder="Seleziona" [options]="tipologieBeni()"
              formControlName="tipologiaBeni" [required]="true" [multiple]="true"
              [optionLabel]="'label'" [optionValue]="'value'" />

            <dpac-select label="Tipologia di risorse digitali" placeholder="Seleziona"
              [options]="tipologiaRisorse()"
              formControlName="tipologiaRisorseDigitali" [required]="true" [multiple]="true"
              [optionLabel]="'label'" [optionValue]="'value'" />

            <div class="col-span-full">
              <dpac-input-field label="Metadati associati alla collezione" placeholder="Metadati associati alla collezione"
                formControlName="presenzaMetadati" />
              <p class="mt-1 text-gray-500 text-xs text-wrap">Se noto, indica tipologia e standard es. descrittivi, strutturali o tecnici; Dublin Core, MAG, METS.</p>
            </div>

            <div class="col-span-full">
              <dpac-textarea label="Note" placeholder="Inserisci qui le note" formControlName="note" [showCharCount]="false" />
            </div>
          </div>
        </section>

        <!-- Sezione: Accesso alla collezione digitale -->
        <section class="mb-8">
          <h3 class="section-title">Accesso alla collezione digitale</h3>

          <div class="gap-x-6 gap-y-4 grid max-md:grid-cols-1 md:grid-cols-2">
            <dpac-select label="Accessibile online?" placeholder="Seleziona" [options]="accessibileOnline()"
              formControlName="accessibileOnline" [required]="true"
              [optionLabel]="'label'" [optionValue]="'value'" />

            @if (formDataDigitale.get('accessibileOnline')?.value === 'si') {
            <dpac-input-field label="Url della collezione" placeholder="https://..." formControlName="url" [required]="true" />
            }

            <dpac-select label="Accessibile in loco?" placeholder="Seleziona" [options]="accessibileLoco()"
              formControlName="accessibileLoco" [required]="true"
              [optionLabel]="'label'" [optionValue]="'value'" />

            @if (formDataDigitale.get('accessibileLoco')?.value === 'si') {
            <dpac-input-field label="Modalità di accesso in loco" placeholder="Modalità di accesso in loco"
              formControlName="modalitaAccesso" [required]="true" />
            }

            @if (formDataDigitale.get('accessibileLoco')?.value === 'no') {
            <div class="col-span-full">
              <dpac-textarea label="Patrimonio digitalizzato non accessibile all'utenza"
                placeholder="Indicare quantità, supporti di conservazione e formati del patrimonio digitalizzato non accessibile"
                formControlName="patrimonioNonAccessibile" [required]="true" [showCharCount]="false" />
            </div>
            }

            <dpac-select
              label="Sei interessato al recupero e all'esposizione dati tramite soluzioni nazionali?"
              placeholder="Seleziona" [options]="soluzioniNazionali()"
              formControlName="soluzioniNazionali" [required]="true"
              [optionLabel]="'label'" [optionValue]="'value'" />

            <dpac-select label="Licenza" placeholder="Seleziona" [options]="licenza()"
              formControlName="licenza"
              [optionLabel]="'label'" [optionValue]="'value'" />
          </div>
        </section>

        <!-- Sezione: Attività di digitalizzazione -->
        <section class="mb-8">
          <h3 class="section-title">Attività di digitalizzazione</h3>

          <div class="gap-x-6 gap-y-4 grid max-md:grid-cols-1 md:grid-cols-2">
            <!-- Progetto: riga intera -->
            <div class="col-span-full">
              <dpac-input-field label="Progetto" placeholder="Progetto" formControlName="progetto" />
            </div>

            <!-- Periodo: da e a sulla stessa riga -->
            <dpac-input-field label="Periodo da" formControlName="periodoFrom" type="month" />
            <dpac-input-field label="Periodo a" formControlName="periodoTo" type="month" />

            <!-- Stato avanzamento e collezione nativa: stessa riga -->
            <dpac-select label="Stato di avanzamento" placeholder="Seleziona" [options]="statoAvanzamento()"
              formControlName="statoAvanzamento"
              [optionLabel]="'label'" [optionValue]="'value'" />

            <dpac-select label="La collezione è nativa digitale?" placeholder="Seleziona" [options]="nativaDigitale()"
              formControlName="nativaDigitale" [required]="true"
              [optionLabel]="'label'" [optionValue]="'value'" />
          </div>
        </section>
      </form>
      }

      <!-- ═══════════════ STEP 3: Informazioni Patrimonio ═══════════════ -->
      @if (current().key === 'fisico') {
      <form [formGroup]="patrimonioFisico">

        <!-- Sezione: Informazioni patrimonio -->
        <section class="mb-8">
          <h3 class="section-title">Informazioni patrimonio</h3>

          <div class="gap-x-6 gap-y-4 grid max-md:grid-cols-1 md:grid-cols-2">
            <div class="col-span-full">
              <dpac-textarea label="Descrizione" placeholder="Descrizione del patrimonio fisico"
                formControlName="descrizioneFisico" [required]="true" [showCharCount]="false" />

            </div>

            <div class="col-span-full">
              <dpac-select label="Dominio" placeholder="Seleziona" [options]="dominio()"
                formControlName="dominio" [required]="true" [multiple]="true"
                [optionLabel]="'label'" [optionValue]="'value'" />
            </div>

            <dpac-input-field label="Condizioni di accesso" placeholder="Condizioni di accesso"
              formControlName="condizioniAccesso" />
            @if (editingAddressPatrimonio()) {
            <dpac-select
              label="Indirizzo sede di conservazione"
              placeholder="Cerca indirizzo..."
              formControlName="indirizzoPatrimonioFisico"
              [options]="addressSuggestionsPatrimonio()"
              [lazy]="true"
              [search]="true"
                [optionLabel]="'indirizzoEsteso'"
                [optionValue]="'indirizzoEsteso'"
              (searchChange)="searchAddressPatrimonio($event)"
              (selectionChange)="onAddressSearchSelect($event, addressSuggestionsPatrimonio(), patrimonioFisico, {addr: 'indirizzoPatrimonioFisico', civ: 'civicoPatrimonioFisico', cap: 'capPatrimonioFisico', city: 'comunePatrimonioFisico', prov: 'provinciaPatrimonioFisico', id: 'indirizzoPatrimonioFisicoId'})"
            />
            } @else {
            <div class="flex items-end gap-2">
              <div class="flex-1">
                <dpac-input-field label="Indirizzo sede di conservazione" formControlName="indirizzoPatrimonioFisico" [readonly]="true" />
              </div>
              <dpac-button label="Modifica" classe="secondary" (onClick)="editingAddressPatrimonio.set(true)" />
            </div>
            }

            <dpac-input-field label="Civico" placeholder="Civico"
              formControlName="civicoPatrimonioFisico" />
            <dpac-input-field label="Cap" placeholder="Cap"
              formControlName="capPatrimonioFisico" />

            <dpac-input-field label="Comune" placeholder="Comune"
              formControlName="comunePatrimonioFisico" />
            <dpac-input-field label="Provincia" placeholder="Provincia"
              formControlName="provinciaPatrimonioFisico" />

            <dpac-select label="Stato di descrizione" placeholder="Seleziona" [options]="catalogato()"
              formControlName="catalogatoInventariatoStato" [required]="true"
              [optionLabel]="'label'" [optionValue]="'value'" labelTooltip=""
              [labelTooltipIcon]="{ src: './assets/icons/Vector.svg', width: 16, height: 16 }"

               />


            @if (patrimonioFisico.get('catalogatoInventariatoStato')?.value &&
                 patrimonioFisico.get('catalogatoInventariatoStato')?.value !== 'CA002') {
              <dpac-select label="Condivisa con i sistemi centrali" placeholder="Seleziona"
                [options]="condivisaConOptions" formControlName="condivisaCon"
                [multiple]="true"
                [optionLabel]="'label'" [optionValue]="'value'" />
              <dpac-input-field label="Sistema descrittivo informatizzato" placeholder="Sistema descrittivo informatizzato"
                formControlName="sistemiInformatizzati" />
              <dpac-input-field label="Strumenti di corredo" placeholder="Strumenti di corredo"
                formControlName="inventariCartacei" />
            }

            <dpac-select
              label="Il proprietario del patrimonio fisico è diverso dal proprietario della collezione digitale?"
              placeholder="Seleziona" [options]="proprietarioDiverso()"
              formControlName="proprietarioDiverso" [required]="true"
              [optionLabel]="'label'" [optionValue]="'value'" />
          </div>
        </section>

        <!-- Sezione: Proprietario Patrimonio Fisico (se diverso) -->
        @if (proprietarioDiversoValue()) {
        <section class="mb-8">
          <h3 class="section-title">Proprietario del Patrimonio Fisico</h3>

          <div class="gap-x-6 gap-y-4 grid max-md:grid-cols-1 md:grid-cols-2">
            <dpac-select label="Seleziona proprietario" placeholder="Seleziona" [options]="selectProprietari"
              formControlName="proprietarioDiversoSelect"
              [optionLabel]="'label'" [optionValue]="'value'" />

            @if (patrimonioFisico.get('proprietarioDiversoSelect')?.value === 0 ||
                 (patrimonioFisico.get('proprietarioDiversoSelect')?.value !== null &&
                  patrimonioFisico.get('proprietarioDiversoSelect')?.value !== undefined &&
                  patrimonioFisico.get('proprietarioDiversoSelect')?.value !== '')) {

            <!-- Tipologia -->
            <dpac-select label="Tipologia" placeholder="Seleziona" [options]="tipologie()"
              formControlName="tipologiaFisico"
              [required]="patrimonioFisico.get('proprietarioDiversoSelect')?.value === 0"
              [readonly]="patrimonioFisico.get('proprietarioDiversoSelect')?.value !== 0"
              [optionLabel]="'label'" [optionValue]="'value'" />

            @if (patrimonioFisico.get('tipologiaFisico')?.value === 'PR004') {
            <dpac-input-field label="Cognome" placeholder="Cognome" formControlName="propCognomeFisico"
              [required]="patrimonioFisico.get('proprietarioDiversoSelect')?.value === 0"
              [readonly]="patrimonioFisico.get('proprietarioDiversoSelect')?.value !== 0" />
            }

            <dpac-input-field
              [label]="patrimonioFisico.get('tipologiaFisico')?.value === 'PR004' ? 'Nome' : 'Nominativo'"
              [placeholder]="patrimonioFisico.get('tipologiaFisico')?.value === 'PR004' ? 'Nome' : 'Nominativo'"
              formControlName="propNomeFisico"
              [required]="patrimonioFisico.get('proprietarioDiversoSelect')?.value === 0"
              [readonly]="patrimonioFisico.get('proprietarioDiversoSelect')?.value !== 0" />

            <dpac-select label="Categoria" placeholder="Seleziona" [options]="categorie()"
              formControlName="categoriaFisico"
              [required]="patrimonioFisico.get('proprietarioDiversoSelect')?.value === 0"
              [readonly]="patrimonioFisico.get('proprietarioDiversoSelect')?.value !== 0"
              [optionLabel]="'label'" [optionValue]="'value'" />

            <dpac-input-field label="Codice identificativo" placeholder="Codice identificativo"
              formControlName="codiceIdentificativoFisico"
              [readonly]="patrimonioFisico.get('proprietarioDiversoSelect')?.value !== 0"
               labelTooltip="ISIL, ESC, Codice fiscale"
              [labelTooltipIcon]="{src: './assets/icons/Vector.svg'}"/>

            @if (patrimonioFisico.get('proprietarioDiversoSelect')?.value === 0) {
              @if (editingAddressSedeLegale()) {
              <dpac-select
                label="Indirizzo (sede legale)"
                placeholder="Cerca indirizzo..."
                formControlName="indirizzoSedeLegaleFisico"
                [required]="true"
                [options]="addressSuggestionsSedeLegale()"
                [lazy]="true"
                [search]="true"
                  [optionLabel]="'indirizzoEsteso'"
                  [optionValue]="'indirizzoEsteso'"
                (searchChange)="searchAddressSedeLegale($event)"
                (selectionChange)="onAddressSearchSelect($event, addressSuggestionsSedeLegale(), patrimonioFisico, {addr: 'indirizzoSedeLegaleFisico', civ: 'civicoPatrimonioProprietario', cap: 'capPatrimonioProprietario', city: 'comunePatrimonioProprietario', prov: 'provinciaPatrimonioProprietario', id: 'indirizzoSedeLegaleFisicoId'})"
              />
              } @else {
              <div class="flex items-end gap-2">
                <div class="flex-1">
                  <dpac-input-field label="Indirizzo (sede legale)" formControlName="indirizzoSedeLegaleFisico" [readonly]="true" [required]="true" />
                </div>
                <dpac-button label="Modifica" classe="secondary" (onClick)="editingAddressSedeLegale.set(true)" />
              </div>
              }
            } @else {
              <!-- Indirizzo in readonly per proprietario esistente -->
              <dpac-input-field label="Indirizzo (sede legale)" formControlName="indirizzoSedeLegaleFisico" [readonly]="true" />
            }

            <dpac-input-field label="Civico" placeholder="Civico"
              formControlName="civicoPatrimonioProprietario"
              [required]="patrimonioFisico.get('proprietarioDiversoSelect')?.value === 0"
              [readonly]="patrimonioFisico.get('proprietarioDiversoSelect')?.value !== 0" />
            <dpac-input-field label="Cap" placeholder="Cap" formControlName="capPatrimonioProprietario"
              [required]="patrimonioFisico.get('proprietarioDiversoSelect')?.value === 0"
              [readonly]="patrimonioFisico.get('proprietarioDiversoSelect')?.value !== 0" />
            <dpac-input-field label="Comune" placeholder="Comune"
              formControlName="comunePatrimonioProprietario"
              [required]="patrimonioFisico.get('proprietarioDiversoSelect')?.value === 0"
              [readonly]="patrimonioFisico.get('proprietarioDiversoSelect')?.value !== 0" />
            <dpac-input-field label="Provincia" placeholder="Provincia"
              formControlName="provinciaPatrimonioProprietario"
              [required]="patrimonioFisico.get('proprietarioDiversoSelect')?.value === 0"
              [readonly]="patrimonioFisico.get('proprietarioDiversoSelect')?.value !== 0" />

            <div class="col-span-full">
              <dpac-input-field label="Sito web dell'ente" placeholder="Sito web dell'ente" formControlName="sitoWebProprietario"
                [readonly]="patrimonioFisico.get('proprietarioDiversoSelect')?.value !== 0" />
            </div>
            }
          </div>
        </section>
        }
      </form>
      }

      <!-- ═══════════════ STEP 4: Visualizzazione mappa ═══════════════ -->
      @if (current().key === 'mappa') {
      <form [formGroup]="visualizzazioneMappa">

        <!-- Sezione: Mappa -->
        <section class="mb-8">
          <h3 class="section-title">Visualizzazione mappa</h3>

          <div class="gap-x-6 gap-y-4 grid max-md:grid-cols-1 md:grid-cols-2">
            <dpac-select label="Mostrare la collezione in mappa?" placeholder="Seleziona" [options]="mappa()"
              formControlName="collezioneMappa" [required]="true"
              [optionLabel]="'label'" [optionValue]="'value'"  />

            @if (visualizzazioneMappa.get('collezioneMappa')?.value === 'si') {
              <dpac-select  label="Indirizzo mappa" placeholder="Seleziona indirizzo"
                [options]="storedIndirizzi()" formControlName="indirizzoMappa" [required]="true"
                [optionLabel]="'label'" [optionValue]="'value'" />
            }
          </div>
        </section>

        <!-- Sezione: Upload -->
        <section class="mb-8">
          <h3 class="section-title">Upload</h3>
          <p class="mb-4 text-gray-600 text-sm">Carica fino a 3 immagini di risorse (formati consentiti: PNG, JPEG, WEBP; dimensione massima 2MB per file), che meglio rappresentano la collezione digitale, poi, definisci tra quelle caricate, quale utilizzare come "copertina" della collezione.</p>


          <dpac-file-upload-zone
            accept=".jpg,.jpeg,.png,.webp"
            placeholder="Trascina qui i file per caricarli"
            [multiple]="true"
            [maxSize]="maxImageSizeBytes"
            (validationError)="onUploadValidationError($event)"
            (filesSelected)="onInputFileReader($event)"
          />


          @if (uploadedFiles().length > 0) {
            <div class="flex flex-col gap-2 mt-4">
              @for (f of uploadedFiles(); track f.id) {
                <div class="flex items-center gap-3 p-3 border border-gray-200 rounded-lg"
                  [class.border-primary-500]="$any(f).isCover"
                  [class.bg-primary-50]="$any(f).isCover">
                  <!-- Thumbnail -->
                  @if ($any(f).thumbnail) {
                    <img [src]="$any(f).thumbnail" [alt]="f.fileName"
                      class="rounded w-14 h-14 object-cover shrink-0" />
                  } @else {
                    <div class="flex justify-center items-center bg-gray-100 rounded w-14 h-14 shrink-0">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="3" y="3" width="18" height="18" rx="2" stroke="#9CA3AF" stroke-width="1.5"/>
                        <circle cx="8.5" cy="8.5" r="1.5" fill="#9CA3AF"/>
                        <path d="M3 15l5-5 4 4 3-3 6 6" stroke="#9CA3AF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </div>
                  }
                  <!-- Name + size -->
                  <div class="flex-1 min-w-0">
                    <p class="font-medium text-gray-900 text-sm truncate">{{ f.fileName }}</p>
                    <p class="text-gray-400 text-xs">{{ $any(f).size ?? '000.0 MB' }}</p>
                  </div>
                  <!-- COPERTINA badge o pulsante selezione -->
                  @if ($any(f).isCover) {
                    <dpac-status-badge label="COPERTINA" variant="success" />
                  } @else {
                    <!-- Pulsante imposta come copertina -->
                    <button type="button"
                      class="font-medium text-primary-600 hover:text-primary-800 text-xs whitespace-nowrap transition-colors"
                      (click)="onSetCover(f.id)">
                      Imposta come copertina
                    </button>
                  }
                  <!-- Delete -->
                  <button type="button" class="p-1 text-gray-400 hover:text-red-500 transition-colors"
                    (click)="onDeleteFile({ file: f })" title="Rimuovi">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M3 6H5H21" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M8 6V4C8 3.47 8.21 2.96 8.59 2.59C8.96 2.21 9.47 2 10 2H14C14.53 2 15.04 2.21 15.41 2.59C15.79 2.96 16 3.47 16 4V6M19 6V20C19 20.53 18.79 21.04 18.41 21.41C18.04 21.79 17.53 22 17 22H7C6.47 22 5.96 21.79 5.59 21.41C5.21 21.04 5 20.53 5 20V6H19Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </button>
                </div>
              }
            </div>
          }
        </section>
      </form>
      }

    </div>
  </div>

</dpac-page-layout>
